"use strict";var r=require("../Guard/isArray.cjs");exports.toArray=function(i,s){return void 0===s&&(s=r.isArray),s(i)?i:[i]};
//# sourceMappingURL=toArray.cjs.map
